<template>
  <div class="text-center">
    <v-dialog
      width="500"
      @click="modalReject"
      :value="isOpenModal"
      persistent
    >
      <v-card>
        <v-card-title class="font-weight-bold">
          {{user.user_code}}({{user.name}})さんへ<br>
          編集権限をリクエストする
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions class="text-center pb-2 justify-center">
          <v-row >
            <v-col cols="6">
              <v-btn
                class="font-weight-bold"
                color="black"
                text
                outlined
                @click="modalReject"
              >
                戻る
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                class="white--text font-weight-bold"
                color='#5E00BC'
                @click="modalResolve"
                type="submit"
              >
                リクエストを送信
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      height: 500,
    };
  },
  name: 'props',
  props: ['user'], 
  computed: {
    isOpenModal() {
			return this.$store.getters['inquiryModal/isOpen']
		},
  },
  methods: {
		modalReject() {
			this.$store.dispatch('inquiryModal/actionModalReject', false)
		},
		modalResolve() {
      this.loading = true;
			this.$store.dispatch('inquiryModal/actionModalResolve', true)
    },
	},
}
</script>